import { CORE_TOOLBAR_IDS } from "contexts/toolbars";

import { Toolbar } from "../Toolbar";

interface DetailsToolbarProps {
    id?: string;
}

/**
 * Presentational toolbar for model details. Registration and sync are handled by
 * useDetailsToolbarRegistration (called from DetailsMenu).
 */
export function DetailsToolbar({ id = CORE_TOOLBAR_IDS.DETAILS }: DetailsToolbarProps) {
    return <Toolbar id={id} />;
}
